import { useQuery } from '@tanstack/react-query';
import IPaginatedParams from '@models/paginated-params';
import {
  getEstablishmentByEnterpriseIdWithThreshold,
  getEstablishmentById,
  getEstablishmentCreditsConsumption,
  getEstablishmentCreditsTopup,
  getEstablishmentSuggestions,
  getEstablishmentSuggestionsByEnterpriseId,
  getEstablishments,
} from '../services/establishmentsService';
import ISearchCriteria from '@models/dto/searchCriteria.dto';

export const useGetEstablishments = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['establishments', paginatedParams, searchCriteria],
    queryFn: () => getEstablishments(paginatedParams, searchCriteria),
    enabled,
  });
};

export const useGetEstablishmentsSuggestions = (
  limit: number,
  page: number,
  query: string,
) => {
  const enabled = query.length > 2;
  const params: IPaginatedParams = { limit, page, query };
  return useQuery({
    queryKey: ['establishment_suggesstions', limit, page, query],
    queryFn: () => getEstablishmentSuggestions(params),
    enabled,
  });
};

export const useGetEstablishmentsSuggestionsByEnterpriseId = (
  limit: number,
  page: number,
  query: string,
  enterpriseId: string,
  enabled: boolean,
) => {
  const params: IPaginatedParams = { limit, page, query };
  return useQuery({
    queryKey: [
      'establishment_suggestions_by_enterprise_id',
      limit,
      page,
      query,
      enterpriseId,
    ],
    queryFn: () =>
      getEstablishmentSuggestionsByEnterpriseId(params, enterpriseId),
    enabled: enabled && !!enterpriseId,
  });
};

export const useGetEstablishmentById = (
  id: string | undefined,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['estabilshment', id],
    queryFn: () => getEstablishmentById(id),
    enabled: !!id && enabled,
  });
};

export const useGetEstablishmentsWithThreshold = (enterpriseId: string) => {
  return useQuery({
    queryKey: [
      'establishment_suggestions_by_enterprise_id_with_threshold',
      enterpriseId,
    ],
    queryFn: () => getEstablishmentByEnterpriseIdWithThreshold(enterpriseId),
    enabled: !!enterpriseId,
  });
};

export const useGetEstablishmentCreditsConsumption = (
  id: string | undefined,
  paginatedParams: IPaginatedParams,
) => {
  return useQuery({
    queryKey: ['establishment_credits_consumption', paginatedParams, id],
    queryFn: () => getEstablishmentCreditsConsumption(id, paginatedParams),
  });
};

export const useGetEStablishmentCreditsTopUp = (
  id: string | undefined,
  paginatedParams: IPaginatedParams,
) => {
  return useQuery({
    queryKey: ['establishment_credits_topup', paginatedParams, id],
    queryFn: () => getEstablishmentCreditsTopup(id, paginatedParams),
  });
};
